import React from "react";

import {service as OrganizationService } from "../../../Services/OrganizationService";
import {service as UserRoleService } from "../../../Services/UserRoleService";

import {TextTableColumn} from "../../Common/Tables/TextTableColumn";

import {StreamBankTable} from "../../../Components/Common/Table/StreamBankTable";

import {ServiceDrivenTableColumn} from "../../Common/FileBrowser/ServiceDrivenTableColumn";
import {UserTableColumn} from "../../Common/Tables/UserTableColumn";

export const UsersTable = React.forwardRef((props, ref) => {
    
    const columnDefs = [
        {
          title: "Name",
          key: "name",
          sortable: true,
          logic: x => x.userId,
          renderer: UserTableColumn
        },
        {
          title: "Organization",
          key: "organization",
          sortable: true,
          logic: x => x.organizationId,
          sortLogic: x => OrganizationService.CachedTitleById(x.organizationId),
          renderer: ServiceDrivenTableColumn(OrganizationService)
        },
        {
          title: "Email",
          key: "email",
          sortable: true,
          logic: x => x.email,
          renderer: TextTableColumn
        },
        {
          title: "Account Role",
          key: "role",
          sortable: true,
          logic: x => x.userRoleId,
          sortLogic: x => UserRoleService.CachedTitleById(x.userRoleId),
          renderer: ServiceDrivenTableColumn(UserRoleService)
        }
    ];

    return <StreamBankTable
        columnDefs={columnDefs}
        itemNamePlural="users"
        getKeyForRow={x => x.userId}
        usesContext={false}

        ref={ref}

        {...props}

    />;
});


